export enum FriendRequestResultStatus {
  Created = 0,
  Accepted = 1,
  InvalidInviteCode = 2,
  OrganizationNotFound = 3,
  SelfRequest = 4,
  AlreadyConnected = 5,
  RequestAlreadyExists = 6
}
